import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3100To3199Service {

  constructor() { }
}
